export const inputRow = {
  padding: "5px",
};

export const submitbtnRow = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "1rem",
};
